import { WORK_ORDER_STEPS } from '@/types/enums';
import z from 'zod';

export const checklistItemSchema = z.object({
  label: z.string(),
  description: z.string().optional().default(''),
  is_required: z.boolean().optional().default(true),
  sort_order: z.number().optional().default(0),
  is_active: z.boolean().optional().default(true),
});

export type ChecklistItem = z.infer<typeof checklistItemSchema>;

const checklistResponseSchema = z.object({
  step: z.enum(WORK_ORDER_STEPS),
  items: z.array(checklistItemSchema),
});

const get = {
  body: z.never(),
  response: checklistResponseSchema,
  params: z.object({
    step: z.enum(WORK_ORDER_STEPS),
  }),
  query: z.never(),
};
const getSchema = z.object(get);
export type Get = z.infer<typeof getSchema>;

const put = {
  body: z.array(checklistItemSchema),
  response: checklistResponseSchema,
  params: z.object({
    step: z.enum(WORK_ORDER_STEPS),
  }),
  query: z.never(),
};
const putSchema = z.object(put);
export type Put = z.infer<typeof putSchema>;

const remove = {
  body: z.never(),
  response: checklistResponseSchema,
  params: z.object({
    step: z.enum(WORK_ORDER_STEPS),
  }),
  query: z.never(),
};
const removeSchema = z.object(remove);
export type Delete = z.infer<typeof removeSchema>;
